<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditDialog="openEditDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <edit-form
      v-if="editFormDialogOptions.visible"
      ref="editForm"
      :type="editFormDialogOptions.type"
      :visible.sync="editFormDialogOptions.visible"
      :amzReplenishmentPeriodCode="editFormDialogOptions.code"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import EditForm from '../edit-form'
import dayjs from '@/libs/util.date'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain, EditForm },
  data() {
    return {
      usePage: true,
      editFormDialogOptions: { visible: false, code: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzPeriodListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          const data = res.body.data
          this.tableData = (data || []).map((item) => {
            const { endDate: date } = item
            if (!date) return item
            const currDate = new Date(dayjs().format('YYYY-MM-DD')).getTime()
            const endDate = new Date(dayjs(date).format('YYYY-MM-DD')).getTime()
            const endDays = (currDate - endDate) / (1000 * 60 * 60 * 24)
            return { ...item, endDays }
          })

          this.page.pageTotal = res.body.count
          this.page.pageSize = res.body.pageSize
          this.page.curPage = res.body.curPage
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, data = {} }) {
      const code = data.amzReplenishmentPeriodCode
      this.editFormDialogOptions = { visible: true, type, code }
    },
  },
}
</script>
